module.exports = __webpack_public_path__ + "static/media/arquitect_5.d8d8bdd2.jpeg";